/**
 * @generated SignedSource<<c872d3e294a9e016b86547128844611f>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type AgentPoolPageCreateAgentPoolMutation$variables = {
  maxAgentsNumber?: number | null | undefined;
  name: string;
};
export type AgentPoolPageCreateAgentPoolMutation$data = {
  readonly createAgentPool: {
    readonly agentPool: {
      readonly __typename: "AgentPool";
      readonly id: string;
      readonly maxAgentsNumber: number | null | undefined;
      readonly name: string | null | undefined;
      readonly permissions: {
        readonly manageProjects: boolean | null | undefined;
      } | null | undefined;
      readonly projects: {
        readonly count: number;
      } | null | undefined;
      readonly rawId: string;
    } | null | undefined;
  } | null | undefined;
};
export type AgentPoolPageCreateAgentPoolMutation = {
  response: AgentPoolPageCreateAgentPoolMutation$data;
  variables: AgentPoolPageCreateAgentPoolMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "maxAgentsNumber"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "name"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "maxAgentsNumber",
            "variableName": "maxAgentsNumber"
          },
          {
            "kind": "Variable",
            "name": "name",
            "variableName": "name"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "CreateAgentPoolPayload",
    "kind": "LinkedField",
    "name": "createAgentPool",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AgentPool",
        "kind": "LinkedField",
        "name": "agentPool",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "rawId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "maxAgentsNumber",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AgentPoolProjectsConnection",
            "kind": "LinkedField",
            "name": "projects",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "count",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AgentPoolPermissions",
            "kind": "LinkedField",
            "name": "permissions",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "manageProjects",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "AgentPoolPageCreateAgentPoolMutation",
    "selections": (v2/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*:: as any*/),
      (v0/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "AgentPoolPageCreateAgentPoolMutation",
    "selections": (v2/*:: as any*/)
  },
  "params": {
    "cacheID": "ebde3e261c7d63de6183e453fe80510c",
    "id": null,
    "metadata": {},
    "name": "AgentPoolPageCreateAgentPoolMutation",
    "operationKind": "mutation",
    "text": "mutation AgentPoolPageCreateAgentPoolMutation(\n  $name: String!\n  $maxAgentsNumber: Int\n) {\n  createAgentPool(input: {name: $name, maxAgentsNumber: $maxAgentsNumber}) {\n    agentPool {\n      id\n      rawId\n      name\n      maxAgentsNumber\n      projects {\n        count\n      }\n      permissions {\n        manageProjects\n      }\n      __typename\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "77ba53cc87129a2cd6b7eb228a75e71f";

export default node;
